import ProgressIndicator from 'components/ProgressIndicator';

import useProgressIndicator from './useProgressIndicator';

const ProgressHeaderIndicator: React.FunctionComponent = function () {
  const { items } = useProgressIndicator();
  return (
    <div className="lg:hidden flex flex-col sticky top-[65px] md:top-[73px] z-50">
      <ProgressIndicator items={items} lastPassed />
    </div>
  );
};

export default ProgressHeaderIndicator;
